import 'aframe'
import 'aframe-effects'
import 'src/aframe/systems/SystemAssetManager'
import 'src/aframe/components/Pattern'
import 'src/aframe/components/ComponentCustomRenderSort'
import 'src/aframe/components/ComponentCameraFOV'
import 'src/aframe/components/ComponentGyroPosition'
import 'src/aframe/components/ComponentTexture'
import 'src/aframe/components/CamDistortion'
import 'src/aframe/components/Sharpen'
import 'src/aframe/components/FilmGrain'
import 'src/aframe/components/Scenes'
import 'src/aframe/components/Spine'
import 'src/aframe/systems/SystemTextureCache'


import Vue from 'vue'
import App from './components/_apps/App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'

Vue.config.productionTip = false

Vue.use(require('vue-moment'))
Vue.use(require('vue-focus'))

// prettier-ignore
Vue.config.ignoredElements = [
  'a-scene',
  'a-camera',
  'a-entity',

  'a-box',
  'a-plane',
  'a-grid',
  'a-sphere',
  'a-image',
  'a-animation',
  'a-text',

  'a-assets',
  'a-asset-item',
  'a-image',
  'a-sound',
  'a-video',
  'a-obj-model',

]

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app')
